import { RICOS_VERSION } from "./../../ricos-schema/next-schema";
const applyBIGenerics = (getContentId) => ({ helpers = {}, ...rest }) => ({
  ...rest,
  helpers: {
    ...helpers,
    onViewerLoaded: (args) => helpers.onViewerLoaded?.({ ...args, version: RICOS_VERSION, contentId: getContentId() }),
    onViewerAction: (pluginId, actionName, value, contentId, partialNode) => helpers.onViewerAction?.(
      pluginId,
      actionName,
      value,
      contentId || getContentId(),
      partialNode
    )
  }
});
export {
  applyBIGenerics
};
//# sourceMappingURL=applyGenericParams.js.map
